export default __webpack_public_path__ + "static/media/img-stake-explorer-mobile.2ddc3b0b.png";